import {get} from "lodash"
import {Deal} from "@irati/types"
import authentication from "@irati/auth"

export default function isZipEnabled(deal: Deal) {
  const fromDeal = get(deal, "paymentOptions.zip.enabled", false)
  const fromPermissions = authentication.apps("platform.payments.zip")

  return fromPermissions && fromDeal
}
